//@ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');
//@ constants
const { EURO_TEXT } = require('constants/index');
const actionTypes = require('constants/actionTypes');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

const setMethod = method => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_METHOD,
    payload: { method }
});

const setInstallments = installments => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_INSTALLMENTS,
    payload: { installments }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_VISIBLE_STEP,
    payload: { step }
});

const setDisabledButton = value => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_DISABLED_BUTTON,
    payload: {
        value,
    }
});

const validateStep = step => (dispatch, getState) => {
    const isRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    dispatch({
        type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_VALIDATE_STEP,
        payload: {
            step,
            isRevolving
        }
    });
};

const setAgreementCheckbox = evt => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SET_AGREEMENT_CHECKBOX,
    payload: {
        checked: evt.target.checked
    }
})

const setWillCancel = willCancel => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_WILL_CANCEL,
    payload: { willCancel }
});

const clearRequest = () => ({ type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_CLEAR });

const successChange = payload => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_SUCCESS,
    payload
});

const failureChange = error => ({
    type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_FAILURE,
    payload: { error }
});

const requestChange = () => ({ type: actionTypes.CARD_CHANGE_PAYMENT_METHOD_REQUEST });

const getPaymentMethodInformationRequest = () => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_REQUEST
});

const getPaymentMethodInformationFailure = error => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_FAILURE,
    payload: { error }
});

const getPaymentMethodInformationSuccess = (response, cardLimit) => ({
    type: actionTypes.CARD_GET_PAYMENT_METHOD_INFORMATION_SUCCESS,
    payload: {
        response,
        cardLimit
    }
});

const postChange = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardChangePaymentMethod = getState().cardChangePaymentMethod.get('steps').get('0');
        const immCard = getState().cards.get('byId').get(cardId);
        const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const contractNumber = immCard.getIn(['contract', 'number']);

        const requestData = {
            query: {
                dataToken,
                codigoMercado: immCardChangePaymentMethod.get('marketCode'),
                codigoMercadoOculto: immCardChangePaymentMethod.get('hiddenMarketCode'),
                contratoTarjeta: {
                    numerodecontrato: contractNumber,
                    producto: immCard.getIn(['contract', 'product'])
                },
                estandarDeReferencia: immCardChangePaymentMethod.get('referenceStandard').toJS(),
                estandarReferenciaOculto: immCardChangePaymentMethod
                    .get('referenceStandard')
                    .toJS(),
                formaDePagoActual: immCardChangePaymentMethod.get('currentPaymentMethod'),
                formaDePagoNueva: immCardChangePaymentMethod.get('method'),
                idRangoFP: immCardChangePaymentMethod.get('newIdRango'),
                importeCuota: {
                    divisa: EURO_TEXT,
                    importe: immCardChangePaymentMethod.get('installments')
                },
                modalidadFormaPagoActual: immCardChangePaymentMethod.get('currentPaymentMode'),
                modalidadFormaPagoOculto: immCardChangePaymentMethod.get(
                    'hiddenCurrentPaymentMode'
                ),
                tipoLiquidacionActual: immCardChangePaymentMethod.get('currentSettlementType'),
                tipoLiquidacionNueva: immCardChangePaymentMethod.get('newSettlementType')
            }
        };

        dispatch(requestChange());
        APIPost({ dispatch, endpoint: 'cardChangePaymentMethodConfirmation', params: requestData })
            .then(response => {
                dispatch(successChange(response))
                if (showIneAndRevolving) {
                    const termsAndsCondsHiringData = [
                        {
                            standard: immCard.getIn(['product', 'standard']),
                            subType: immCard.getIn(['product', 'subtype']),
                            type: immCard.getIn(['product', 'type'])
                        }
                    ];
                    dispatch(setTermsAndCondsInfoRevolving(immCard.get('standarAlias'), termsAndsCondsHiringData, contractNumber));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(failureChange(response.error));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const requestPaymentMethodInfo = cardId => (dispatch, getState) => {
    const immCard = getState().cards.get('byId').get(cardId);
    const cardLimit = immCard.getIn(['limit', 'amount']);
    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product'], ''),
            numeroContrato: immCard.getIn(['contract', 'number'], '')
        }
    };

    dispatch(getPaymentMethodInformationRequest());
    return APIGet({ dispatch, endpoint: 'cardChangePaymentMethod', params: requestData })
        .then(response => dispatch(getPaymentMethodInformationSuccess(response, cardLimit)))
        .catch(response => {
            if (!!response.error) {
                dispatch(getPaymentMethodInformationFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    setAgreementCheckbox,
    setMethod,
    setInstallments,
    setVisibleStep,
    setDisabledButton,
    validateStep,
    setWillCancel,
    postChange,
    clearRequest,
    requestPaymentMethodInfo
};
